import React, { FunctionComponent } from 'react';
import styled from 'styled-components';
import { isEmpty } from 'ts-utils';
import { Color } from '../../config/Color';
import { appOverride } from '../../util/AppUtils';
import { BodySM, BodyXXS, Heading4 } from './Typography';

export type TestimonialProps = {
  name: string;
  image?: string;
  testimonial: string[];
  date: string;
  stars: number;
};

export const Testimonial: FunctionComponent<TestimonialProps> = (props) => {
  const { name, image, testimonial, date, stars } = props;

  return (
    <div>
      <FloatingTestimonial>
        <CleanTestimonial name={name} date={date} stars={stars} body={testimonial} image={image} />
      </FloatingTestimonial>
    </div>
  );
};

type IbsType = 'IBS-C' | 'IBS-D' | 'IBS-M' | 'IBS';
type CleanTestimonialProps = {
  image?: string;
  name: string;
  stars?: number;
  date: string;
  ibsType?: IbsType;
  body: string[];
};

export const CleanTestimonial: FunctionComponent<CleanTestimonialProps> = (props) => {
  const { image, name, stars = 0, date, ibsType, body } = props;

  return (
    <Container data-test="testimonialContainer">
      {!isEmpty(image) && <Image src={image} />}
      <Header>
        <TopHeader style={{ marginTop: 12 }}>
          <Heading4 style={{ margin: 0 }}>{name}</Heading4>
          <Stars>
            {Array(stars)
              .fill(0)
              .map(() => '★ ')
              .join('')}
          </Stars>
        </TopHeader>
      </Header>
      <Body>
        {body.map((text: string, index: number) => (
          <BodySM key={index}>{text}</BodySM>
        ))}
        <BodyXXS>
          {!isEmpty(ibsType) && `${ibsType}, `}
          {date}
        </BodyXXS>
      </Body>
    </Container>
  );
};

const FloatingTestimonial = styled.div`
  position: relative;
  text-align: left;
`;

const Image = styled.img`
  max-width: 100%;
`;

const Header = styled.div`
  padding: ${({ theme }) => `${theme.spacing._6px} ${theme.spacing._20px}`};
`;
const Body = styled.div`
  padding: ${({ theme }) => `${theme.spacing._10px} ${theme.spacing._20px} ${theme.spacing._20px}`};
`;

const Stars = styled.span`
  color: ${Color.star};
  margin: auto 0px;
`;

const TopHeader = styled.div`
  padding: ${({ theme }) => theme.spacing._2px};
  display: flex;
  justify-content: space-between;
`;

const Container = styled.div`
  margin: ${({ theme }) => `${theme.spacing._20px} 0`};
  background: ${appOverride({ nerva: Color.surface.onAccent, default: Color.surface.muted })};
`;
